/*

--------------------------------------------------------------------------------
Oriflame extension for Kendo date / time pickers
--------------------------------------------------------------------------------

*/

; (function ($) {

    "use strict";

    var kendo = window.kendo;
    if (!kendo) return;

    var proxy = $.proxy,
        support = kendo.support,
        Widget = kendo.ui.Widget,
        PLACEHOLDER = "placeholder",
        AVATAR = "avatar",
        ATTR_TITLE = "title",
        ATTR_VAL_UI_TYPE = "valUi",
        widgets = ["DatePicker", "DateTimePicker", "TimePicker"],
        DEFAULT = 'k-state-default',
        DISABLED = 'disabled',
        STATEDISABLED = 'k-state-disabled',
        ARIA_DISABLED = 'aria-disabled',
        READONLY = 'readonly',
        STATEREADONLY = "k-state-readonly",
        ARIA_READONLY = 'aria-readonly',
        FOCUSED = 'k-state-focused',
        activeElement = kendo._activeElement;

    function preventDefault(e) {
        e.preventDefault();
    }

    /**
     * Apply states rather on main wrapper.
     */
    function datePickerBlur() {
        var self = this;
        self.close();
        self._change(self.element.val());
        self.wrapper.removeClass(FOCUSED);
    }

    /**
     * Overwrite of original editable for DatePicker now also moves styles and needed events to top wrapper (widget wrapper)
     */
    function datePickerEditable(options) {
        var self = this,
            NS = ".kendoDatePicker",
            HOVEREVENTS = 'mouseenter' + NS + ' mouseleave' + NS,
            CLICK = 'click' + NS,
            MOUSEDOWN = 'mousedown' + NS,
            icon = self._dateIcon.off(NS),
            element = self.element.off(NS),
            wrapper = self._inputWrapper.off(NS),
            topWrapper = self.wrapper.off(NS),
            readonly = options.readonly,
            disable = options.disable;
        if (!readonly && !disable) {
            wrapper
                .removeClass(STATEDISABLED)
                .removeClass(STATEREADONLY);
            topWrapper
                .addClass(DEFAULT)
                .removeClass(STATEDISABLED)
                .removeClass(STATEREADONLY)
                .on(HOVEREVENTS, self._toggleHover);
            element
                .prop(DISABLED, false)
                .prop(READONLY, false)
                .attr(ARIA_DISABLED, false)
                .attr(ARIA_READONLY, false)
                .on('keydown' + NS, proxy(self._keydown, self))
                .on('focusout' + NS, function () {
                    self.wrapper.removeClass(FOCUSED);
                    proxy(self._blur, self);
                })
                .on('focus' + NS, function () {
                    self.wrapper.addClass(FOCUSED);
                });
            icon
                .on(CLICK, proxy(self._click, self))
                .on(MOUSEDOWN, preventDefault);
        } else {
            if (readonly) {
                wrapper.removeClass(DEFAULT).removeClass(STATEDISABLED);
                topWrapper.addClass(STATEREADONLY).removeClass(DEFAULT).removeClass(STATEDISABLED);
            }
            if (disable) {
                wrapper.removeClass(DEFAULT).removeClass(STATEREADONLY);
                topWrapper.addClass(STATEDISABLED).removeClass(DEFAULT).removeClass(STATEREADONLY);
            }
            element.prop(DISABLED, disable).prop(READONLY, readonly).attr(ARIA_DISABLED, disable).attr(ARIA_READONLY, readonly);
        }
    }

    /**
     * Overwrite of original editable for DateTimePicker now also moves styles and needed events to top wrapper (widget wrapper)
     */
    function dateTimePickerEditable(options) {
        var self = this,
            NS = ".kendoDateTimePicker",
            HOVEREVENTS = 'mouseenter' + NS + ' mouseleave' + NS,
            CLICK = 'click' + NS,
            MOUSEDOWN = 'mousedown' + NS,
            element = self.element.off(NS),
            dateIcon = self._dateIcon.off(NS),
            timeIcon = self._timeIcon.off(NS),
            wrapper = self._inputWrapper.off(NS),
            topWrapper = self.wrapper.off(NS),
            readonly = options.readonly,
            disable = options.disable;
        if (!readonly && !disable) {
            wrapper
                .removeClass(STATEDISABLED)
                .removeClass(STATEREADONLY);
            topWrapper
                .addClass(DEFAULT)
                .removeClass(STATEDISABLED)
                .removeClass(STATEREADONLY)
                .on(HOVEREVENTS, self._toggleHover);
            element
                .prop(DISABLED, false)
                .prop(READONLY, false)
                .attr(ARIA_DISABLED, false)
                .attr(ARIA_READONLY, false)
                .on('keydown' + NS, $.proxy(self._keydown, self))
                .on('focus' + NS, function () {
                    self.wrapper.addClass(FOCUSED);
                })
                .on('focusout' + NS, function () {
                    self.wrapper.removeClass(FOCUSED);
                    if (element.val() !== self._oldText) {
                        self._change(element.val());
                    }
                    self.close('date');
                    self.close('time');
                });
            dateIcon
                .on(MOUSEDOWN, preventDefault)
                .on(CLICK, function () {
                    self.toggle('date');
                    if (!kendo.support.touch && element[0] !== activeElement()) {
                        element.focus();
                    }
                });
            timeIcon
                .on(MOUSEDOWN, preventDefault)
                .on(CLICK, function () {
                    self.toggle('time');
                    if (!kendo.support.touch && element[0] !== activeElement()) {
                        element.focus();
                    }
                });
        } else {
            if (readonly) {
                wrapper.removeClass(DEFAULT).removeClass(STATEDISABLED);
                topWrapper.addClass(STATEREADONLY).removeClass(DEFAULT).removeClass(STATEDISABLED)
                    .on('blur' + NS, function () {
                        this.removeClass(FOCUSED);
                    });
            }
            if (disable) {
                wrapper.removeClass(DEFAULT).removeClass(STATEREADONLY);
                topWrapper.addClass(STATEDISABLED).removeClass(DEFAULT).removeClass(STATEREADONLY);
            }
            element
                .prop(DISABLED, disable)
                .prop(READONLY, readonly)
                .attr(ARIA_DISABLED, disable)
                .attr(ARIA_READONLY, readonly);
        }
    }

    /**
     * Overwrite of original editable for TimePicker now also moves styles and needed events to top wrapper (widget wrapper)
     */
    function timePickerEditable(options) {
        var self = this,
            NS = ".kendoTimePicker",
            HOVEREVENTS = 'mouseenter' + NS + ' mouseleave' + NS,
            CLICK = 'click' + NS,
            MOUSEDOWN = 'mousedown' + NS,
            disable = options.disable,
            readonly = options.readonly,
            arrow = self._arrow.off(NS),
            element = self.element.off(NS),
            wrapper = self._inputWrapper.off(NS),
            topWrapper = self.wrapper.off(NS);
        if (!readonly && !disable) {
            wrapper
                .removeClass(STATEDISABLED)
                .removeClass(STATEREADONLY);
            topWrapper
                .addClass(DEFAULT)
                .removeClass(STATEDISABLED)
                .removeClass(STATEREADONLY)
                .on(HOVEREVENTS, self._toggleHover);
            element
                .prop(DISABLED, false)
                .prop(READONLY, false)
                .attr(ARIA_DISABLED, false)
                .attr(ARIA_READONLY, false)
                .on('keydown' + NS, proxy(self._keydown, self))
                .on('focusout' + NS, function () {
                    self.wrapper.removeClass(FOCUSED);
                    proxy(self._blur, self);
                })
                .on('focus' + NS, function () {
                    self.wrapper.addClass(FOCUSED);
                });
            arrow
                .on(CLICK, proxy(self._click, self))
                .on(MOUSEDOWN, preventDefault);
        } else {
            if (readonly) {
                wrapper.removeClass(DEFAULT).removeClass(STATEDISABLED);
                topWrapper.addClass(STATEREADONLY).removeClass(DEFAULT).removeClass(STATEDISABLED);
            }
            if (disable) {
                wrapper.removeClass(DEFAULT).removeClass(STATEREADONLY);
                topWrapper.addClass(STATEDISABLED).removeClass(DEFAULT).removeClass(STATEREADONLY);
            }
            element.prop(DISABLED, disable).prop(READONLY, readonly).attr(ARIA_DISABLED, disable).attr(ARIA_READONLY, readonly);
        }
    }

    /**
     * The original widget "class" gets updated in two steps. First is constructor
     * update. newInit function becomes the new constructor of the component.
     * In the constructor the widget is also republished as kendo plugin, so that
     * jQuery.fn gets updated. Second step is overriding of specific widget methods
     * when needed.
     */
    function updateWidget(widgetName) {
        var widget = kendo.ui[widgetName];
        if (!widget || widget.updated) return;
        var NS = ".kendo" + widgetName,
            oldWidgetInit = widget.fn.init,
            newWidgetInit = function (element, options) {
                var self = this,
                    $element = $(element);
                // update options from specifically prefixed data on element
                options = kendo.elementOptions($element, widgetName.toLowerCase(), options);
                if (options.enabled === undefined)
                    options.enabled = !$element.is("[disabled]");
                if (options.readonly === undefined)
                    options.readonly = $element.is("[readonly]");
                // remove avatar class before the wrapper gets created
                $element.removeClass(AVATAR);
                // call original constructor
                oldWidgetInit.call(self, element, options);
                // update placeholder in options to be sure
                self.options.placeholder = self.options.placeholder || self.element.attr(PLACEHOLDER);
                // remember title text - needed for various description UI types
                // execute with caution to not remove the title by mistake
                self.options.titleText = self.options.titleText || self.element.attr(ATTR_TITLE);
                self.element.removeAttr(ATTR_TITLE);
                // update validation UI type in options to be sure
                self.options.validationUi = self.options.validationUi || self.element.data(ATTR_VAL_UI_TYPE);
                // monitor keystrokes for placeholder
                if (!support.placeholder && typeof self._keyup == "function")
                    self.element.on("keyup" + NS, proxy(self._keyup, self));
                // update title / tooltip popups
                Widget.fn.descriptionUi.call(self);
                // remove input class from wrapper for easier styling
                self.wrapper.removeClass("k-input");
            };

        var _newEditable = (NS === ".kendoDatePicker" ? datePickerEditable : (NS === ".kendoDateTimePicker" ? dateTimePickerEditable : timePickerEditable));

        widget = widget.extend({
            // new init
            init: newWidgetInit,
            // default options extension
            options: kendo.getUpdatedWidgetOptions(),
            // updated methods
            _toggleHover: kendo.toggleHoverOnWrapper,
            _blur: datePickerBlur,
            _editable: _newEditable
        });

        kendo.updatePlaceholderLogic(widget);

        widget.updated = true;

        kendo.ui.plugin(widget);
    }

    // updates to all date / time pickers are the same for now
    for (var i = 0; i < widgets.length; i++)
        updateWidget(widgets[i]);

})(window.kendo.jQuery);
